<template>
  <div>
    <header class="d-flex justify-content-between py-2">
      <router-link to="/" class="col-auto crm-logo">
        <img src="@/assets/icecreamIn.svg" width="180px" class="img-fluid" alt="">
      </router-link>

      <div class="d-flex">
        <!--<notification :counter="4"/>-->
        <user/>
        <!-- Agency no-login order link session: hide logout/new-order (client request) -->
        <button v-if="!$store.getters.isAgencyLink" class="btn btn-sm btn-danger" @click="$store.dispatch('logout')">{{$t('message.logout')}}</button>
        <div v-if="!$store.getters.isAgencyLink" class="mx-1"></div>
        <button v-if="!$store.getters.isAgencyLink" class="btn btn-sm btn-primary" @click="openNewOrder()">{{$t('message.openNewOrder')}}</button>
      </div>

    </header>
  </div>
</template>


<script>
import notification from '@/components/notification'
import user from '@/components/user'
import axios from "@/axios";


export default {
  name: 'toolbar',
  components: {notification, user},

  data: function () {
    return {
      'newOrderUrl': '',
      'newUrlAddition': ''
    }
  },

  methods: {
    async openNewOrder() {
      let userId = this.$store.getters.userId;
      switch (this.$store.getters.isHostName) {
        case 'localhost':
        case '10front-stage.hova.co.il':
          this.newOrderUrl = `https://10b.co.il/test/?aff=${userId}&src=1`;
          break;
        default:
          this.newOrderUrl = `https://10b.co.il/web/?aff=${userId}&src=1`;
      }

      // Proves this click really came from a logged-in agent here - minted fresh per click,
      // so it has to happen before we navigate, not baked into a static link.
      try {
        const res = await axios.post('users/issueAgentHandoffToken');
        this.newOrderUrl += `&rtoken=${res.data.token}`;
      } catch (e) {
        alert('לא ניתן היה לאמת את המשתמש, נסה שוב');
        return;
      }

      window.open(this.newOrderUrl, '_blank');
    }
  }
}
</script>


